import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Flex, Text } from 'components/ui';
import { mediaQueries, space } from 'style/config';
import Empty from 'constants/empty';

/**
 * Renders display-only Benefits rows with the configured icon and text.
 */
const BenefitIconList = ({ benefits = Empty.Array, columns = 2 }) => {
    if (!benefits.length) {
        return null;
    }

    return (
        <Box css={columns === 3 ? styles.threeColumnList : styles.twoColumnList}>
            {benefits.map((benefit, index) => (
                <Flex
                    key={benefit.id || benefit.title || index}
                    alignItems='flex-start'
                    gap={2}
                    lineHeight='tight'
                >
                    {benefit.icon && (
                        <Text
                            aria-hidden={true}
                            flexShrink={0}
                            fontSize='base'
                            lineHeight='tight'
                            children={benefit.icon}
                        />
                    )}
                    <Text
                        is='span'
                        fontSize='base'
                        lineHeight='tight'
                        children={benefit.title}
                    />
                </Flex>
            ))}
        </Box>
    );
};

const styles = {
    twoColumnList: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        columnGap: space[6],
        rowGap: space[4],
        [mediaQueries.smMax]: {
            gridTemplateColumns: '1fr',
            rowGap: space[3]
        }
    },
    threeColumnList: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        columnGap: space[6],
        rowGap: space[4],
        [mediaQueries.smMax]: {
            gridTemplateColumns: '1fr',
            rowGap: space[3]
        }
    }
};

export default wrapFunctionalComponent(BenefitIconList, 'BenefitIconList');
